<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="img"><img alt="image" src="images/p4.jpg"/></p>
<h1 class="toc">CONTENTS</h1>
<p class="start2"></p>
<p class="toc"><a href="#/dish">A DISH FOR EVERY DAY</a></p>
<p class="start1"></p>
<p class="toc"><a href="#/cap01">JANUARY</a></p>
<p class="toc"><a href="#/cap02">FEBRUARY</a></p>
<p class="toc"><span href="#/cap03" title="Link target outside of Sample">MARCH</span></p>
<p class="toc"><span href="#/cap04" title="Link target outside of Sample">APRIL</span></p>
<p class="toc"><span href="#/cap05" title="Link target outside of Sample">MAY</span></p>
<p class="toc"><span href="#/cap06" title="Link target outside of Sample">JUNE</span></p>
<p class="toc"><span href="#/cap07" title="Link target outside of Sample">JULY</span></p>
<p class="toc"><span href="#/cap08" title="Link target outside of Sample">AUGUST</span></p>
<p class="toc"><span href="#/cap09" title="Link target outside of Sample">SEPTEMBER</span></p>
<p class="toc"><span href="#/cap10" title="Link target outside of Sample">OCTOBER</span></p>
<p class="toc"><span href="#/cap11" title="Link target outside of Sample">NOVEMBER</span></p>
<p class="toc"><span href="#/cap12" title="Link target outside of Sample">DECEMBER</span></p>
<p class="start1"></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">INDEX</span></p>
<p class="toc"><span href="#/copyright" title="Link target outside of Sample">COPYRIGHT</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2410acae